// router/index.js
// Updated with role-based guards and locations route

import { createRouter, createWebHashHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';

// ---------------------------------------------------------------
// Guard helpers
// ---------------------------------------------------------------

function requireAuth(to, from, next) {
  const token = localStorage.getItem('userToken');
  if (!token) {
    next('/login');
  } else {
    next();
  }
}

function requireRole(minimumRole) {
  const hierarchy = { god: 4, superadmin: 3, location_admin: 2, user: 1 };

  return (to, from, next) => {
    const token = localStorage.getItem('userToken');
    if (!token) {
      return next('/login');
    }
    const role      = localStorage.getItem('userRole') || 'user';
    const userLevel = hierarchy[role]    || 0;
    const reqLevel  = hierarchy[minimumRole] || 0;

    if (userLevel >= reqLevel) {
      next();
    } else {
      // Redirect to dashboard with a flag so we can show a snackbar
      next({ name: 'dashboard', query: { forbidden: 1 } });
    }
  };
}

// ---------------------------------------------------------------
// Routes
// ---------------------------------------------------------------

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: HomeView,
    beforeEnter: requireAuth,
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
  },
  {
    path: '/fooditems',
    name: 'fooditems',
    component: () => import('../views/LabelView.vue'),
    beforeEnter: requireAuth,
  },
  {
    path: '/categories',
    name: 'categories',
    component: () => import('../views/CategoryView.vue'),
    beforeEnter: requireAuth,
  },
  {
    path: '/devices',
    name: 'devices',
    component: () => import('../views/DevicesView.vue'),
    beforeEnter: requireRole('superadmin'),
  },
  {
    path: '/users',
    name: 'users',
    component: () => import('../views/UsersView.vue'),
    beforeEnter: requireRole('superadmin'),
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/SettingsView.vue'),
    beforeEnter: requireAuth,
  },
  {
    path: '/label-designer',
    name: 'label-designer',
    component: () => import('../views/LabelDesignerView.vue'),
    beforeEnter: requireRole('superadmin'),
  },
  {
    path: '/labels',
    name: 'labels',
    component: () => import('../views/LabelsView.vue'),
    beforeEnter: requireAuth,
  },
  {
    path: '/configurations',
    name: 'configurations',
    component: () => import('../views/ConfigurationsView.vue'),
    beforeEnter: requireRole('superadmin'),
  },
  {
    path: '/locations',
    name: 'locations',
    component: () => import('../views/LocationsView.vue'),
    beforeEnter: requireRole('superadmin'),
  },
  {
    path: '/menus',
    name: 'Menus',
    component: () => import('@/views/MenusView.vue'),
    meta: { requiresAuth: true }
  },
  { 
    path: '/impersonate', 
    name: 'impersonate', 
    component: () => import('@/views/ImpersonateView.vue'), 
    beforeEnter: requireRole('god'),
  }
];

// ---------------------------------------------------------------
// Router instance
// ---------------------------------------------------------------

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// ---------------------------------------------------------------
// Global guard — catch any authenticated route without a token
// ---------------------------------------------------------------
router.beforeEach((to, from, next) => {
  const publicRoutes = ['login', 'about'];
  const isPublic     = publicRoutes.includes(to.name);
  const token        = localStorage.getItem('userToken');

  if (!isPublic && !token) {
    next('/login');
  } else {
    next();
  }
});

export default router;